import { render, staticRenderFns } from "./MiniTileComp.vue?vue&type=template&id=5e2eb166&scoped=true&"
import script from "./MiniTileComp.vue?vue&type=script&lang=ts&"
export * from "./MiniTileComp.vue?vue&type=script&lang=ts&"
import style0 from "./MiniTileComp.vue?vue&type=style&index=0&id=5e2eb166&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2eb166",
  null
  
)

export default component.exports